/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react';
export const useDebouncedCallback = (func, delay) => {
    const [attemptCall, setAttemptCall] = useState(0);
    const funcRef = useRef(func);
    const lastArgs = useRef([]);
    const lastThis = useRef();
    useEffect(() => {
        funcRef.current = func;
    }, [func]);
    useEffect(() => {
        if (attemptCall <= 0)
            return;
        const handler = setTimeout(() => {
            funcRef.current.apply(lastThis.current, lastArgs.current);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [attemptCall]);
    return (...args) => {
        lastArgs.current = args;
        lastThis.current = this;
        setAttemptCall(call => call + 1);
    };
};
